import { useQuery, useQueryClient, UseQueryResult } from '@tanstack/react-query'
import TourService, {
  Tour, TourDetails

} from '../services/tours'

const TourKeys = {
  all: () => ['tours', 'list'] as const,
  get: (id: string) => ['tours', id] as const
}

export function useTours (): {
  tours?: Tour[]
  toursLoading: boolean
  toursError?: unknown
} {
  const { data: tours = [], isPending, error } = useQuery({
    queryKey: TourKeys.all(),
    queryFn: async () => {
      const tourService = new TourService()
      return await tourService.all()
    }
  })
  return { tours, toursLoading: isPending, toursError: error }
}

export function useTour (tourId?: string): UseQueryResult<TourDetails> {
  const queryClient = useQueryClient()
  return useQuery({
    queryKey: TourKeys.get(tourId ?? 'none'),
    queryFn: async () => {
      const tourService = new TourService()
      if (tourId !== undefined) {
        return await tourService.getTour(tourId)
      }
      return null
    },
    enabled: tourId !== undefined,
    initialData: () => {
      const tourData = queryClient.getQueryData<Tour[]>(TourKeys.all())
      if (tourData !== undefined) {
        const tour = tourData.find((tour) => tour.id === tourId)
        if (tour !== undefined) {
          return {
            first_departure: null,
            last_departure: null,
            first_available: null,
            id: tour.id,
            tours: [tour]
          }
        }
        return undefined
      }
    }
  })
}
